module.exports = __webpack_public_path__ + "img/1.4a5e21e2.png";